import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';
import { TASK_MODEL } from 'services/entity/task';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: TASK_MODEL.taskName.label,
    field: 'multiTaskName',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: TASK_MODEL.taskType.label,
    field: TASK_MODEL.taskType.id,
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: TASK_MODEL.description.label,
    field: TASK_MODEL.description.id,
    width: LIST_WIDTH.xxl,
  },
  {
    headerName: TASK_MODEL.numSchedule.label,
    field: TASK_MODEL.numSchedule.id,
    width: LIST_WIDTH.sm,
  },
  // {
  //   headerName: TASK_MODEL.numSubtask.label,
  //   field: TASK_MODEL.numSubtask.id,
  //   width: LIST_WIDTH.sm,
  // },
  {
    headerName: TASK_MODEL.numEvidence.label,
    field: TASK_MODEL.numEvidence.id,
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'QR Code',
    field: 'btnData',
    width: LIST_WIDTH.s,
    cellRenderer: 'downloadBtn',
    cellRendererParams: {
      columnKey: 'taskName',
    },
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];
